<template>

    <div class="signup-page">
        <Header></Header>
        <section class="signup-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Create Artist</h2>
                        <form class="form" v-on:submit.prevent="signupFormSubmit">
                            <div class="input-field form-input">
                                <label for="your-name">Your Name</label>
                                <input type="text" placeholder="Full Name" id="your-name" v-model="name"
                                       v-on:blur="yourName(name)">
                                <p class="error-input" v-if="nameFlag">Full Name is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-email">Your Email</label>
                                <input type="text" placeholder="johndoe@email.com" id="your-email" v-model="email"
                                       v-on:blur="yourEmail(email)">
                                <p class="error-input" v-if="emailFlag">Email address is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-password">Password</label>
                                <input type="password" placeholder="*******" v-model="password" id="your-password"
                                       v-on:blur="yourPassword(password)">
                                <p class="error-input" v-if="passwordFlag">Password is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="confirm-password">Confirm Password</label>
                                <input type="password" placeholder="*******" v-model="confirmPassword" id="confirm-password"
                                       v-on:blur="confirmYourPassword(confirmPassword)">
                                <p class="error-input" v-if="confirmPasswordFlag">Confirm Password is required</p>
                            </div>
                            <div class="input-submit">
                                <input type="hidden" v-model="admin" />
                                <button type="submit" v-if="!FormSubmited">SAVE</button>
                                <span v-if="FormSubmited">SAVE...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import axios from 'axios'
    import router from '../../../router'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    export default {
        name: 'ArtistCreate',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        data() {
            return {
                nameFlag: false,
                emailFlag: false,
                passwordFlag: false,
                confirmPasswordFlag: false,
                FormSubmited: false,
                email: '',
                name: '',
                password: '',
                admin: 'admin',
                confirmPassword: '',
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {
            yourName: function (msg) {
                if (!msg) {
                    this.nameFlag = true
                } else {
                    this.nameFlag = false
                }
            },
            yourEmail: function (msg) {
                if (!msg) {
                    this.emailFlag = true
                } else {
                    this.emailFlag = false
                }
            },
            yourPassword: function (msg) {
                if (!msg) {
                    this.passwordFlag = true
                } else {
                    this.passwordFlag = false
                }
            },
            confirmYourPassword: function (msg) {
                if (!msg) {
                    this.confirmPasswordFlag = true
                } else {
                    this.confirmPasswordFlag = false
                }
            },
            signupFormSubmit: function (event) {
                if(this.password == this.confirmPassword){
                    this.FormSubmited = true
                    if(this.email){
                        this.email = this.email.trim().toLowerCase()
                    }
                    try {
                        axios.post('/signup', {
                            name: this.name,
                            email: this.email,
                            password: this.password,
                            admin: this.admin
                        }).then(res => {
                            this.FormSubmited = false
                            if(res.data.error == "User already exists"){
                                Vue.$toast.open(
                                    {
                                        message: 'User already exists',
                                        type: 'error',
                                        position: 'top-right'
                                        // all other options
                                    }
                                )
                            } else {
                                Vue.$toast.open(
                                    {
                                        message: 'User Created!',
                                        type: 'success',
                                        position: 'top-right'
                                        // all other options
                                    }
                                )
                                router.push({ name: 'ArtistList' })
                            }
                        }).catch(err => {
                            this.FormSubmited = false
                            console.log(err)
                        })
                    } catch (e) {
                        this.FormSubmited = false
                        console.log(e)
                    }
                } else {
                    Vue.$toast.open(
                        {
                            message: 'Password mis-smatch',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/artists/Create.vue